// extracted by mini-css-extract-plugin
export default {"left_box":"index_left_box_tuUzM","dbox":"index_dbox_5Up7L"};